import React, { useEffect } from "react";
import { useI18n } from "../i18n/i18n";

export default function ClearPlannedModal({
    isOpen,
    count,
    onConfirm,
    onClose,
}) {
    const { t } = useI18n();

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div
            className="clearPlannedModalOverlay"
            role="dialog"
            aria-modal="true"
            aria-labelledby="clearPlannedModalTitle"
            onClick={onClose}
        >
            <div
                className="clearPlannedModalContent"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="clearPlannedModalHeader">
                    <h3 id="clearPlannedModalTitle" className="clearPlannedModalTitle">
                        {t("home.clearPlannedModalTitle")}
                    </h3>
                    <button
                        type="button"
                        className="clearPlannedModalClose"
                        onClick={onClose}
                        aria-label={t("common.close")}
                    >
                        &times;
                    </button>
                </div>

                <div className="clearPlannedModalBody">
                    <p className="clearPlannedModalQuestion">
                        {t("home.clearPlannedModalQuestion", { count: count || 0 })}
                    </p>
                    <p className="clearPlannedModalNote">
                        {t("home.clearPlannedModalNote")}
                    </p>
                </div>

                <div className="clearPlannedModalActions">
                    <button
                        type="button"
                        className="appButton appButton--secondary clearPlannedCancelButton"
                        onClick={onClose}
                    >
                        {t("home.clearPlannedCancel")}
                    </button>
                    <button
                        type="button"
                        className="appButton clearPlannedConfirmButton"
                        onClick={onConfirm}
                    >
                        {t("home.clearPlannedConfirm")}
                    </button>
                </div>
            </div>
        </div>
    );
}
